// extracted by mini-css-extract-plugin
export default {"dialog_min_width":"320px","dialog_full_width":"800px"};